import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Search,
  Filter,
  Download,
  User,
  Mail,
  Calendar,
  Shield,
  CheckCircle,
  XCircle,
  Users,
  Eye,
  X,
  ChevronLeft,
  ChevronRight,
  RefreshCw,
  Wallet,
  Check,
  Phone,
  Plus,
  CheckSquare,
  XSquare,
  AlertCircle,
  Key,
  Edit,
  Lock,
  Unlock,
  ShieldOff,
  ArrowUpDown,
  Clock,
  LogIn,
} from "lucide-react";
import WalletModal from "./WalletModal";
import { Modal, Button, message, Input, Select, Tooltip, Spin } from "antd";
import AuthForm from "./Auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Option } = Select;
const { Password } = Input;

// set this to your API base (or use env var)
const API_BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "";

// Helper function to format date only (dd/mm/yyyy)
const formatDateOnly = (dateString) => {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    return "-";
  }
};

const formatDateOnlyAnniversssary = (dateString) => {
  console.log(dateString);

  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (error) {
    return "-";
  }
};
// Helper function to format date and time (dd/mm/yyyy, hh:mm am/pm)
const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedHours = String(hours).padStart(2, "0");

    return `${day}/${month}/${year}, ${formattedHours}:${minutes} ${ampm}`;
  } catch (error) {
    return "-";
  }
};

const RoleBadge = ({ role }) => {
  const base =
    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";
  if (role === "admin")
    return (
      <span className={`${base} bg-red-100 text-red-800`}>
        <Shield className="w-3 h-3 mr-1" />
        Admin
      </span>
    );
  if (role === "user")
    return (
      <span className={`${base} bg-blue-100 text-blue-800`}>
        <User className="w-3 h-3 mr-1" />
        User
      </span>
    );
  return <span className={`${base} bg-gray-100 text-gray-800`}>{role}</span>;
};

const VerifiedBadge = ({ v }) =>
  v ? (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-green-100 text-green-800 text-xs font-medium">
      <CheckCircle className="w-3 h-3 mr-1" /> Verified
    </span>
  ) : (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-red-100 text-red-800 text-xs font-medium">
      <XCircle className="w-3 h-3 mr-1" /> Not Verified
    </span>
  );

const DeactivatedBadge = ({ deactivated }) =>
  deactivated ? (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-red-100 text-red-800 text-xs font-medium">
      <Lock className="w-3 h-3 mr-1" /> Deactivated
    </span>
  ) : (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-green-100 text-green-800 text-xs font-medium">
      <Unlock className="w-3 h-3 mr-1" /> Active
    </span>
  );

const downloadCSV = (rows, filename = "users.csv") => {
  if (!rows || !rows.length) return;
  const keys = Object.keys(rows[0]);
  const csvContent = [
    keys.join(","),
    ...rows.map((r) =>
      keys
        .map((k) => {
          let v = r[k];
          if (v === null || v === undefined) return "";
          if (typeof v === "object") {
            if (v.username) return `"${v.username}"`;
            return `"${JSON.stringify(v).replace(/"/g, '""')}"`;
          }
          const s = String(v).replace(/"/g, '""');
          return `"${s}"`;
        })
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", filename);
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const AllUserTable = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [openWalletModel, setOpenWalletModel] = useState(false);
  const [walletUser, setWalletUser] = useState(null);

  // Add User Modal state
  const [openAddUserModal, setOpenAddUserModal] = useState(false);

  // Verify User states
  const [verifyingUserId, setVerifyingUserId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [verifying, setVerifying] = useState(false);

  // Date range filters
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Deactivation filter
  const [showDeactivated, setShowDeactivated] = useState(false);

  // modal state for referrals
  const [showRefModal, setShowRefModal] = useState(false);
  const [referrals, setReferrals] = useState([]);
  const [refModalUser, setRefModalUser] = useState(null);
  const [refModalLoading, setRefModalLoading] = useState(false);
  const [refPage, setRefPage] = useState(1);
  const [refLimit, setRefLimit] = useState(10);
  const [refTotal, setRefTotal] = useState(0);
  const [refSearch, setRefSearch] = useState("");

  // New modals
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showDeactivationModal, setShowDeactivationModal] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  const [newRole, setNewRole] = useState("user");
  const [newVerificationStatus, setNewVerificationStatus] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [deactivationStatus, setDeactivationStatus] = useState(false);
  const [deactivationReason, setDeactivationReason] = useState("");

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editFormData, setEditFormData] = useState({
    username: "",
    email: "",
    phone: "",
    gender: "",
    hometowncity: "",
    city: "",
    DOB: "",
    Aniversary: "",
    password: "",
    role: "user",
  });
  const [editingSubmit, setEditingSubmit] = useState(false);

  const openEditModal = (user) => {
    setEditingUser(user);
    setEditFormData({
      username: user.username || "",
      email: user.email || "",
      phone: user.phone || "",
      gender: user.gender || "",
      hometowncity: user.hometowncity || "",
      city: user.city || "",
      DOB: user.DOB ? user.DOB.split("T")[0] : "",
      Aniversary: user.Aniversary ? user.Aniversary.split("T")[0] : "",
      password: "",
      role: user.role || "user",
    });
    setShowEditModal(true);
  };

  const submitEditUser = async () => {
    setEditingSubmit(true);
    try {
      const res = await axios.put(`${API_BASE}/api/auth/admin/${editingUser._id}`, editFormData, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      if (res.data.success) {
        toast.success("User updated successfully");
        setShowEditModal(false);
        fetchUsers();
      } else {
        toast.error(res.data.message || "Failed to update user");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error updating user");
    } finally {
      setEditingSubmit(false);
    }
  };

  // Loading states for specific operations
  const [updatingRoleUserId, setUpdatingRoleUserId] = useState(null);
  const [updatingVerificationUserId, setUpdatingVerificationUserId] =
    useState(null);
  const [changingPasswordUserId, setChangingPasswordUserId] = useState(null);
  const [togglingActivationUserId, setTogglingActivationUserId] =
    useState(null);
  const [loggingInUserId, setLoggingInUserId] = useState(null);
  const [loginAsUserModal, setLoginAsUserModal] = useState({
    open: false,
    user: null,
  });

  const handleLoginAsUser = async (targetUser) => {
    if (!targetUser?._id) return;
    if (targetUser.isDeactivated) {
      toast.error(
        "Cannot login as a deactivated user. Please reactivate the account first."
      );
      return;
    }
    if (!targetUser.isVerified) {
      toast.error(
        "Cannot login as an unverified user. Please verify the user first."
      );
      return;
    }

    setLoggingInUserId(targetUser._id);
    try {
      const res = await axios.post(
        `${API_BASE}/api/auth/admin/userlogin`,
        { userId: targetUser._id },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (res.data?.success) {
        toast.success(
          `Logged in as ${
            targetUser.username || targetUser.email || "user"
          }! Redirecting to user panel...`,
          { autoClose: 2000 }
        );
        setLoginAsUserModal({ open: false, user: null });

        const userData = {
          id: targetUser._id,
          name: targetUser.username || targetUser.name || "User",
          username: targetUser.username || targetUser.name || "User",
          email: targetUser.email,
          role: (targetUser.role || "user").toLowerCase(),
          phone: targetUser.phone || "",
        };

        // Clear previous admin details from localStorage, sessionStorage, and cookies
        try {
          const keysToRemove = [
            "admin",
            "adminToken",
            "adminUser",
            "admin_token",
            "admin_user",
            "admin_details",
            "auth-storage",
            "user",
            "token",
            "authToken",
          ];
          keysToRemove.forEach((k) => localStorage.removeItem(k));
          sessionStorage.clear();

          // Clear client cookies for admin
          document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.celestialtours.net;";
          document.cookie = "adminToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "adminToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.celestialtours.net;";

          // Clear cache storage if supported
          if ("caches" in window) {
            caches.keys().then((names) => {
              names.forEach((name) => caches.delete(name));
            });
          }

          // Store credentials and token of the user logged in by admin
          localStorage.setItem(
            "auth-storage",
            JSON.stringify({
              state: { user: userData, registeredUsers: [] },
              version: 0,
            })
          );
          localStorage.setItem("user", JSON.stringify(userData));
          if (res.data?.token) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("authToken", res.data.token);
            document.cookie = `authToken=${res.data.token}; path=/; max-age=172800; SameSite=Lax;`;
            document.cookie = `authToken=${res.data.token}; path=/; domain=.celestialtours.net; max-age=172800; SameSite=Lax;`;
          }
        } catch (e) {
          console.error("Storage clear/save error:", e);
        }

        // Cross-domain redirection: Pass credentials in query params to celestialtours.net
        const targetUrl = new URL("https://celestialtours.net");
        targetUrl.searchParams.set("auth_user", JSON.stringify(userData));
        if (res.data?.token) {
          targetUrl.searchParams.set("auth_token", res.data.token);
        }

        setTimeout(() => {
          window.location.href = targetUrl.toString();
        }, 800);
      } else {
        toast.error(res.data?.message || "Failed to login as user.");
        setLoggingInUserId(null);
      }
    } catch (err) {
      console.error("Login as user error:", err);
      toast.error(
        err.response?.data?.message ||
          err.message ||
          "Failed to login as user."
      );
      setLoggingInUserId(null);
    }
  };

  const [showFilters, setShowFilters] = useState(false);
  const [activeFilters, setActiveFilters] = useState(0);

  const removeKeys = ["password", "verifyToken", "__v", "_id"];

  const prevFiltersRef = useRef({
    search: "",
    startDate: "",
    endDate: "",
    limit: 10,
    showDeactivated: false,
  });

  // Debug: Log user fields to check anniversary field name
  useEffect(() => {
    if (users.length > 0) {
      const firstUser = users[0];
      // console.log("First user fields:", Object.keys(firstUser));

      // Check for anniversary related fields
      const anniversaryFields = Object.keys(firstUser).filter(
        (k) =>
          k.toLowerCase().includes("anniversary") ||
          k.toLowerCase().includes("wedding") ||
          k.toLowerCase().includes("marriage")
      );

      if (anniversaryFields.length > 0) {
        // console.log("Anniversary related fields found:", anniversaryFields);
        anniversaryFields.forEach((field) => {
          // console.log(`Field "${field}" value:`, firstUser[field]);
        });
      } else {
        // console.log("No anniversary related fields found in user data");
      }
    }
  }, [users]);

  useEffect(() => {
    let count = 0;
    if (search) count++;
    if (startDate) count++;
    if (endDate) count++;
    if (showDeactivated) count++;
    setActiveFilters(count);
  }, [search, startDate, endDate, showDeactivated]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const params = {
        page,
        limit,
        sortField,
        sortOrder,
      };

      if (search.trim()) params.search = search.trim();
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (showDeactivated) params.isDeactivated = "true";

      const url = `${API_BASE}/api/auth/users`;
      const { data } = await axios.get(url, {
        params,
        withCredentials: true,
      });

      if (data && data.data) {
        setUsers(data.data);
        setTotalCount(data.totalCount || 0);
      } else {
        setUsers([]);
        setTotalCount(0);
      }
    } catch (err) {
      console.error("fetchUsers error:", err);
      setUsers([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filtersChanged =
      prevFiltersRef.current.search !== search ||
      prevFiltersRef.current.startDate !== startDate ||
      prevFiltersRef.current.endDate !== endDate ||
      prevFiltersRef.current.limit !== limit ||
      prevFiltersRef.current.showDeactivated !== showDeactivated;

    if (filtersChanged && page !== 1) {
      setPage(1);
      prevFiltersRef.current = {
        search,
        startDate,
        endDate,
        limit,
        showDeactivated,
      };
      return;
    }

    prevFiltersRef.current = {
      search,
      startDate,
      endDate,
      limit,
      showDeactivated,
    };

    fetchUsers();
  }, [
    page,
    limit,
    search,
    sortField,
    sortOrder,
    startDate,
    endDate,
    showDeactivated,
  ]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    if (page !== 1) setPage(1);
  };

  const openReferralsModal = async (user) => {
    setRefModalUser(user);
    setShowRefModal(true);
    setRefPage(1);
    setRefSearch("");
    await loadReferrals(user._id, 1, refLimit, "");
  };

  const loadReferrals = async (userId, p = 1, lim = 10, s = "") => {
    setRefModalLoading(true);
    try {
      const params = { page: p, limit: lim };
      if (s) params.search = s;

      const url = `${API_BASE}/api/user/referrals/${userId}`;
      const { data } = await axios.get(url, {
        params,
        withCredentials: true,
      });
      if (data && data.data) {
        setReferrals(data.data);
        setRefTotal(data.totalCount || 0);
        setRefPage(p);
      } else {
        setReferrals([]);
        setRefTotal(0);
      }
    } catch (err) {
      console.error("loadReferrals error:", err);
      setReferrals([]);
      setRefTotal(0);
    } finally {
      setRefModalLoading(false);
    }
  };

  const handleExport = () => {
    const rows = users.map((u) => {
      const r = { ...u };
      removeKeys.forEach((k) => delete r[k]);
      if (r.refUserId && typeof r.refUserId === "object") {
        r.refUserId = r.refUserId.username || "";
      }
      return r;
    });
    const filterText = showDeactivated ? "_deactivated" : "";
    downloadCSV(rows, `users${filterText}_page${page}.csv`);
  };

  const handleClearFilters = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");
    setShowDeactivated(false);
    setSortField("createdAt");
    setSortOrder("desc");
    setPage(1);
  };

  const handleUserAdded = () => {
    fetchUsers();
    setOpenAddUserModal(false);
  };

  const handleVerifyUser = (userId) => {
    setVerifyingUserId(userId);
    setShowConfirmModal(true);
  };

  const confirmVerifyUser = async () => {
    if (!verifyingUserId) return;

    setVerifying(true);
    try {
      const response = await axios.put(
        `${API_BASE}/api/auth/${verifyingUserId}/verify`,
        {},
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        message.success(response.data.message || "User verified successfully!");
        fetchUsers();
        showToast("User verified successfully!", "success");
      } else {
        message.error(response.data.message || "Failed to verify user");
        showToast(response.data.message || "Failed to verify user", "error");
      }
    } catch (error) {
      console.error("Verify user error:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Failed to verify user. Please try again.";
      message.error(errorMsg);
      showToast(errorMsg, "error");
    } finally {
      setVerifying(false);
      setShowConfirmModal(false);
      setVerifyingUserId(null);
    }
  };

  // New Functions
  const openRoleModal = (user) => {
    setSelectedUser(user);
    setNewRole(user.role);
    setShowRoleModal(true);
  };

  const openVerificationModal = (user) => {
    setSelectedUser(user);
    setNewVerificationStatus(user.isVerified);
    setShowVerificationModal(true);
  };

  const openPasswordModal = (user) => {
    setSelectedUser(user);
    setNewPassword("");
    setConfirmPassword("");
    setShowPasswordModal(true);
  };

  const openDeactivationModal = (user) => {
    setSelectedUser(user);
    setDeactivationStatus(user.isDeactivated || false);
    setDeactivationReason("");
    setShowDeactivationModal(true);
  };

  const updateUserRole = async () => {
    if (!selectedUser) return;

    setUpdatingRoleUserId(selectedUser._id);
    try {
      const response = await axios.put(
        `${API_BASE}/api/auth/${selectedUser._id}/role`,
        { role: newRole },
        { withCredentials: true }
      );

      if (response.data.success) {
        message.success(response.data.message);
        fetchUsers();
        setShowRoleModal(false);
        showToast("User role updated successfully!", "success");
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to update role");
    } finally {
      setUpdatingRoleUserId(null);
    }
  };

  const updateUserVerification = async () => {
    if (!selectedUser) return;

    setUpdatingVerificationUserId(selectedUser._id);
    try {
      const response = await axios.put(
        `${API_BASE}/api/auth/${selectedUser._id}/verification`,
        { isVerified: newVerificationStatus },
        { withCredentials: true }
      );

      if (response.data.success) {
        message.success(response.data.message);
        fetchUsers();
        setShowVerificationModal(false);
        showToast(
          `User verification ${
            newVerificationStatus ? "enabled" : "disabled"
          }!`,
          "success"
        );
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to update verification"
      );
    } finally {
      setUpdatingVerificationUserId(null);
    }
  };

  const changeUserPassword = async () => {
    if (!selectedUser) return;

    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match!");
      return;
    }

    if (newPassword.length < 8) {
      message.error("Password must be at least 8 characters long!");
      return;
    }

    // Check if password contains at least one alphabet (letter)
    if (!/[a-zA-Z]/.test(newPassword)) {
      message.error("Password must contain at least one alphabet (letter)!");
      return;
    }

    setChangingPasswordUserId(selectedUser._id);
    try {
      const response = await axios.put(
        `${API_BASE}/api/auth/${selectedUser._id}/password`,
        { newPassword },
        { withCredentials: true }
      );

      if (response.data.success) {
        message.success("Password changed successfully!");
        setShowPasswordModal(false);
        showToast("Password changed successfully!", "success");
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to change password"
      );
    } finally {
      setChangingPasswordUserId(null);
    }
  };

  const toggleUserActivation = async () => {
    if (!selectedUser) return;

    setTogglingActivationUserId(selectedUser._id);
    try {
      const payload = { isDeactivated: deactivationStatus };
      if (deactivationStatus && deactivationReason) {
        payload.deactivationReason = deactivationReason;
      }

      const response = await axios.put(
        `${API_BASE}/api/auth/${selectedUser._id}/activation`,
        payload,
        { withCredentials: true }
      );

      if (response.data.success) {
        message.success(response.data.message);
        fetchUsers();
        setShowDeactivationModal(false);
        showToast(
          `User ${deactivationStatus ? "deactivated" : "reactivated"}!`,
          "success"
        );
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to update activation status"
      );
    } finally {
      setTogglingActivationUserId(null);
    }
  };

  const showToast = (message, type = "success") => {
    if (type === "success") {
      toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const headers = users.length
    ? Object.keys(users[0]).filter((k) => !removeKeys.includes(k))
    : [];

  console.log(users);

  const safeValue = (u, key) => {
    const val = u[key];
    if (key === "totalReferrals")
      return typeof val === "number" ? val : Number(val) || 0;
    return val;
  };

  const handlePageJump = (val) => {
    const p = Number(val);
    const maxPage = Math.ceil(totalCount / (limit || 1));
    if (!isNaN(p) && p >= 1 && p <= maxPage) {
      setPage(p);
    }
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / (limit || 1)));

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                User Management
              </h1>
              <p className="text-gray-600 mt-1">
                Manage and monitor all registered users
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => setOpenAddUserModal(true)}
                className="inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg font-medium hover:from-purple-600 hover:to-purple-700 transition-all shadow-md"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add User
              </button>

              <button
                onClick={toggleSortOrder}
                className="inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-indigo-500 to-indigo-600 text-white rounded-lg font-medium hover:from-indigo-600 hover:to-indigo-700 transition-all shadow-md"
              >
                <ArrowUpDown className="w-4 h-4 mr-2" />
                {sortOrder === "desc" ? "Newest First" : "Oldest First"}
              </button>

              <button
                onClick={handleClearFilters}
                className="inline-flex items-center px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors shadow-sm"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Clear Filters
              </button>
              <button
                onClick={handleExport}
                disabled={users.length === 0}
                className="inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg font-medium hover:from-green-600 hover:to-green-700 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Download className="w-4 h-4 mr-2" />
                Export CSV
              </button>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-6">
            <div className="bg-white rounded-xl p-4 shadow border border-gray-200">
              <div className="flex items-center">
                <div className="p-2 bg-blue-50 rounded-lg">
                  <Users className="w-5 h-5 text-blue-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm text-gray-600">Total Users</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {totalCount}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-4 shadow border border-gray-200">
              <div className="flex items-center">
                <div className="p-2 bg-green-50 rounded-lg">
                  <CheckCircle className="w-5 h-5 text-green-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm text-gray-600">Verified Users</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {users.filter((u) => u.isVerified).length}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-4 shadow border border-gray-200">
              <div className="flex items-center">
                <div className="p-2 bg-purple-50 rounded-lg">
                  <Lock className="w-5 h-5 text-purple-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm text-gray-600">Deactivated Users</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {users.filter((u) => u.isDeactivated).length}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-4 shadow border border-gray-200">
              <div className="flex items-center">
                <div className="p-2 bg-orange-50 rounded-lg">
                  <Filter className="w-5 h-5 text-orange-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm text-gray-600">Active Filters</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {activeFilters}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-4 shadow border border-gray-200">
              <div className="flex items-center">
                <div className="p-2 bg-indigo-50 rounded-lg">
                  <Calendar className="w-5 h-5 text-indigo-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm text-gray-600">Current Page</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {page}/{totalPages}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 mb-6 overflow-hidden">
          <div className="p-5">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="Search by username, email, or name..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

              <button
                onClick={() => setShowFilters(!showFilters)}
                className="inline-flex items-center px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all shadow-md"
              >
                <Filter className="w-4 h-4 mr-2" />
                Filters
                {activeFilters > 0 && (
                  <span className="ml-2 bg-white text-blue-600 text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {activeFilters}
                  </span>
                )}
              </button>
            </div>

            {/* Expandable Filters */}
            {showFilters && (
              <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 animate-fadeIn">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <Calendar className="w-4 h-4 inline mr-1" />
                      Created From
                    </label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <Calendar className="w-4 h-4 inline mr-1" />
                      Created To
                    </label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Rows per page
                    </label>
                    <select
                      value={limit}
                      onChange={(e) => setLimit(Number(e.target.value))}
                      className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                    >
                      <option value={6}>6 per page</option>
                      <option value={10}>10 per page</option>
                      <option value={20}>20 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                      <option value={0}>All</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Account Status
                    </label>
                    <select
                      value={showDeactivated ? "deactivated" : "all"}
                      onChange={(e) =>
                        setShowDeactivated(e.target.value === "deactivated")
                      }
                      className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                    >
                      <option value="all">All Users</option>
                      <option value="deactivated">Deactivated Only</option>
                      {/* <option value="active">Active Only</option> */}
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Table Container - scrollable horizontally and vertically */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          {loading ? (
            <div className="text-center py-16">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
              <p className="mt-4 text-gray-600 font-medium">
                Loading users data...
              </p>
              <p className="text-sm text-gray-500">Please wait</p>
            </div>
          ) : (
            <>
              <div className="overflow-x-auto overflow-y-auto max-h-[380px]">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gradient-to-r from-gray-800 to-gray-900 sticky top-0 z-10">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider"
                      >
                        ID
                      </th>
                      {headers.map((h) => (
                        <th
                          key={h}
                          scope="col"
                          className={`px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider ${
                            [
                              "username",
                              "email",
                              "gender",
                              "role",
                              "isVerified",
                              "isDeactivated",
                              "totalReferrals",
                              "createdAt",
                              "updatedAt",
                            ].includes(h)
                              ? "cursor-pointer hover:bg-gray-700 transition-colors"
                              : ""
                          }`}
                          onClick={() =>
                            [
                              "username",
                              "email",
                              "gender",
                              "role",
                              "isVerified",
                              "isDeactivated",
                              "totalReferrals",
                              "createdAt",
                              "updatedAt",
                            ].includes(h)
                              ? handleSort(h)
                              : null
                          }
                        >
                          <div className="flex items-center justify-between">
                            <span>
                              {h === "isVerified"
                                ? "Verified"
                                : h === "isDeactivated"
                                ? "Status"
                                : h === "totalReferrals"
                                ? "Total Referrals"
                                : h === "createdAt"
                                ? "Created At"
                                : h === "updatedAt"
                                ? "Updated At"
                                : h === "DOB"
                                ? "Date of Birth"
                                : h === "anniversary"
                                ? "Anniversary"
                                : h.charAt(0).toUpperCase() + h.slice(1)}
                            </span>
                            {sortField === h && (
                              <span className="ml-2">
                                {sortOrder === "asc" ? "↑" : "↓"}
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                      <th
                        scope="col"
                        className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider"
                      >
                        Actions
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider"
                      >
                        Wallet
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {users.length === 0 ? (
                      <tr>
                        <td
                          colSpan={headers.length + 3}
                          className="px-6 py-12 text-center"
                        >
                          <div className="flex flex-col items-center justify-center">
                            <User className="w-12 h-12 text-gray-400 mb-3" />
                            <p className="text-gray-900 font-medium">
                              No users found
                            </p>
                            <p className="text-gray-500 text-sm mt-1">
                              Try adjusting your filters or search terms
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      users.map((u, idx) => (
                        <tr
                          key={u._id}
                          className={`hover:bg-gray-50 transition-colors ${
                            u.isDeactivated ? "bg-red-50" : ""
                          }`}
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-800 rounded-full">
                              {(page - 1) * (limit || 1) + idx + 1}
                            </span>
                          </td>

                          {headers.map((key) => {
                            if (key === "isVerified") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap"
                                >
                                  <VerifiedBadge v={u[key]} />
                                </td>
                              );
                            }

                            if (key === "isDeactivated") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap"
                                >
                                  <DeactivatedBadge deactivated={u[key]} />
                                </td>
                              );
                            }

                            if (key === "refUserId") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  {u.refUserId?.username ? (
                                    <span className="inline-flex items-center px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-xs">
                                      {u.refUserId.username}
                                    </span>
                                  ) : (
                                    <span className="text-gray-400">-</span>
                                  )}
                                </td>
                              );
                            }

                            if (key === "totalReferrals") {
                              const count = safeValue(u, key);
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap"
                                >
                                  <div className="flex items-center">
                                    <Users className="w-4 h-4 text-gray-400 mr-2" />
                                    <span
                                      className={`text-sm font-semibold ${
                                        count > 0
                                          ? "text-green-600"
                                          : "text-gray-600"
                                      }`}
                                    >
                                      {count}
                                    </span>
                                  </div>
                                </td>
                              );
                            }

                            if (key === "createdAt" || key === "updatedAt") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  <div className="flex flex-col">
                                    <div className="flex items-center">
                                      <Calendar className="w-4 h-4 text-gray-400 mr-2" />
                                      {formatDateTime(u[key])}
                                    </div>
                                  </div>
                                </td>
                              );
                            }

                            if (key === "DOB") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  <div className="flex items-center">
                                    <Calendar className="w-4 h-4 text-gray-400 mr-2" />
                                    {formatDateOnly(u[key])}
                                  </div>
                                </td>
                              );
                            }

                            // Handle anniversary field - check multiple possible field names
                            if (
                              key === "Aniversary" ||
                              key === "Anniversary" ||
                              key === "anniversaryDate" ||
                              key === "weddingDate" ||
                              key.toLowerCase().includes("anniversary") ||
                              key.toLowerCase().includes("wedding")
                            ) {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  <div className="flex items-center">
                                    <Calendar className="w-4 h-4 text-gray-400 mr-2" />
                                    {key == "anniversary"
                                      ? formatDateOnlyAnniversssary(u[key])
                                      : formatDateOnly(u[key])}
                                  </div>
                                </td>
                              );
                            }

                            // Handle other date fields like verifiedAt, deactivatedAt, etc.
                            if (
                              key.includes("At") &&
                              (key === "verifiedAt" || key === "deactivatedAt")
                            ) {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  <div className="flex items-center">
                                    <Calendar className="w-4 h-4 text-gray-400 mr-2" />

                                    {formatDateTime(u[key])}
                                  </div>
                                </td>
                              );
                            }

                            if (key === "role") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap"
                                >
                                  <RoleBadge role={u[key]} />
                                </td>
                              );
                            }

                            if (key === "email") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  <div className="flex items-center">
                                    <Mail className="w-4 h-4 text-gray-400 mr-2" />
                                    <span className="truncate max-w-[200px]">
                                      {String(u[key] ?? "")}
                                    </span>
                                  </div>
                                </td>
                              );
                            }

                            if (key === "username") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                >
                                  <div className="flex items-center">
                                    <User className="w-4 h-4 text-gray-400 mr-2" />
                                    {String(u[key] ?? "")}
                                  </div>
                                </td>
                              );
                            }

                            if (key === "gender") {
                              return (
                                <td
                                  key={key}
                                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                >
                                  <div className="flex items-center">
                                    <span
                                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                                        u[key] === "male"
                                          ? "bg-blue-100 text-blue-800"
                                          : u[key] === "female"
                                          ? "bg-pink-100 text-pink-800"
                                          : "bg-gray-100 text-gray-800"
                                      }`}
                                    >
                                      {String(u[key] ?? "")
                                        .charAt(0)
                                        .toUpperCase() +
                                        String(u[key] ?? "").slice(1)}
                                    </span>
                                  </div>
                                </td>
                              );
                            }

                            return (
                              <td
                                key={key}
                                className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                              >
                                {typeof u[key] === "object" && u[key] !== null
                                  ? u[key]?.username
                                  : String(u[key] ?? "")}
                              </td>
                            );
                          })}

                          {/* Actions Column */}
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex flex-col gap-2">
                              <button
                                onClick={() => openReferralsModal(u)}
                                className="inline-flex items-center px-3 py-1.5 bg-gradient-to-r from-indigo-500 to-indigo-600 text-white rounded-lg text-xs font-medium hover:from-indigo-600 hover:to-indigo-700 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={loading}
                              >
                                <Eye className="w-3 h-3 mr-1" />
                                View Referrals
                              </button>

                              <div className="grid grid-cols-2 gap-2 mt-2">
                                <Tooltip title="Edit User">
                                  <button
                                    onClick={() => openEditModal(u)}
                                    className="inline-flex items-center justify-center px-2 py-1.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg text-xs font-medium hover:from-blue-600 hover:to-blue-700 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    <Edit className="w-3 h-3" />
                                  </button>
                                </Tooltip>
                                <Tooltip title="Change Role">
                                  <button
                                    onClick={() => openRoleModal(u)}
                                    disabled={updatingRoleUserId === u._id}
                                    className="inline-flex items-center justify-center px-2 py-1.5 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg text-xs font-medium hover:from-purple-600 hover:to-purple-700 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    {updatingRoleUserId === u._id ? (
                                      <Spin size="small" />
                                    ) : (
                                      <Shield className="w-3 h-3" />
                                    )}
                                  </button>
                                </Tooltip>

                                <Tooltip title="Change Verification">
                                  <button
                                    onClick={() => openVerificationModal(u)}
                                    disabled={
                                      updatingVerificationUserId === u._id
                                    }
                                    className="inline-flex items-center justify-center px-2 py-1.5 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white rounded-lg text-xs font-medium hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    {updatingVerificationUserId === u._id ? (
                                      <Spin size="small" />
                                    ) : (
                                      <CheckSquare className="w-3 h-3" />
                                    )}
                                  </button>
                                </Tooltip>

                                <Tooltip title="Change Password">
                                  <button
                                    onClick={() => openPasswordModal(u)}
                                    disabled={changingPasswordUserId === u._id}
                                    className="inline-flex items-center justify-center px-2 py-1.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg text-xs font-medium hover:from-blue-600 hover:to-blue-700 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    {changingPasswordUserId === u._id ? (
                                      <Spin size="small" />
                                    ) : (
                                      <Key className="w-3 h-3" />
                                    )}
                                  </button>
                                </Tooltip>

                                <Tooltip
                                  title={
                                    u.isDeactivated
                                      ? "Reactivate User"
                                      : "Deactivate User"
                                  }
                                >
                                  <button
                                    onClick={() => openDeactivationModal(u)}
                                    disabled={
                                      togglingActivationUserId === u._id
                                    }
                                    className={`inline-flex items-center justify-center px-2 py-1.5 rounded-lg text-xs font-medium transition-all shadow-sm ${
                                      u.isDeactivated
                                        ? "bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700"
                                        : "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700"
                                    } text-white disabled:opacity-50 disabled:cursor-not-allowed`}
                                  >
                                    {togglingActivationUserId === u._id ? (
                                      <Spin size="small" />
                                    ) : u.isDeactivated ? (
                                      <Unlock className="w-3 h-3" />
                                    ) : (
                                      <Lock className="w-3 h-3" />
                                    )}
                                  </button>
                                </Tooltip>

                                <Tooltip title="Login as User">
                                  <button
                                    onClick={() =>
                                      setLoginAsUserModal({
                                        open: true,
                                        user: u,
                                      })
                                    }
                                    disabled={
                                      loggingInUserId === u._id || loading
                                    }
                                    className="inline-flex items-center justify-center px-2 py-1.5 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-lg text-xs font-medium hover:from-emerald-600 hover:to-teal-700 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    {loggingInUserId === u._id ? (
                                      <Spin size="small" />
                                    ) : (
                                      <LogIn className="w-3 h-3" />
                                    )}
                                  </button>
                                </Tooltip>
                              </div>
                            </div>
                          </td>

                          {/* Wallet Column */}
                          <td className="px-6 py-4 whitespace-nowrap">
                            <button
                              onClick={() => {
                                setWalletUser(u);
                                setOpenWalletModel(true);
                              }}
                              className="p-2 rounded-lg hover:bg-green-100 transition disabled:opacity-50 disabled:cursor-not-allowed"
                              title="Add Wallet"
                              disabled={loading}
                            >
                              <Wallet className="w-5 h-5 text-green-600" />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {limit > 0 && (
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="text-sm text-gray-700">
                      Showing{" "}
                      <span className="font-semibold">
                        {users.length > 0 ? (page - 1) * limit + 1 : 0}
                      </span>{" "}
                      -{" "}
                      <span className="font-semibold">
                        {Math.min(page * limit, totalCount)}
                      </span>{" "}
                      of <span className="font-semibold">{totalCount}</span>{" "}
                      users
                    </div>

                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => setPage((p) => Math.max(1, p - 1))}
                        disabled={page <= 1 || loading}
                        className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                      >
                        <ChevronLeft className="w-4 h-4 mr-1" />
                        Previous
                      </button>

                      <div className="flex items-center space-x-2">
                        <span className="text-sm text-gray-700">Page</span>
                        <input
                          type="number"
                          min={1}
                          max={totalPages}
                          value={page}
                          onChange={(e) => handlePageJump(e.target.value)}
                          className="w-16 px-2 py-1.5 border border-gray-300 rounded text-center text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                        <span className="text-sm text-gray-700">
                          of {totalPages}
                        </span>
                      </div>

                      <button
                        onClick={() =>
                          setPage((p) => Math.min(totalPages, p + 1))
                        }
                        disabled={page >= totalPages || loading}
                        className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                      >
                        Next
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* ✅ Add User Modal */}
      <Modal
        title="Add New User"
        open={openAddUserModal}
        onCancel={() => setOpenAddUserModal(false)}
        footer={null}
        width={800}
        centered
        className="add-user-modal"
        styles={{
          content: {
            borderRadius: "20px",
          },
        }}
      >
        <div className="max-h-[70vh] overflow-y-auto pr-2">
          <AuthForm isAdminMode={true} onUserAdded={handleUserAdded} />
        </div>
      </Modal>

      {/* ✅ Verify User Confirmation Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <CheckSquare className="w-5 h-5 text-green-600" />
            <span>Verify User</span>
          </div>
        }
        open={showConfirmModal}
        onCancel={() => {
          setShowConfirmModal(false);
          setVerifyingUserId(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => setShowConfirmModal(false)}
            disabled={verifying}
          >
            Cancel
          </Button>,
          <Button
            key="verify"
            type="primary"
            onClick={confirmVerifyUser}
            loading={verifying}
            className="bg-green-600 hover:bg-green-700 border-green-600"
            disabled={verifying}
          >
            {verifying ? "Verifying..." : "Verify User"}
          </Button>,
        ]}
        centered
      >
        <div className="py-4">
          <div className="flex items-center justify-center mb-4">
            <AlertCircle className="w-12 h-12 text-yellow-500" />
          </div>
          <p className="text-center text-gray-700 mb-2 font-medium">
            Confirm User Verification
          </p>
          <p className="text-center text-sm text-gray-500 mb-4">
            Are you sure you want to verify this user account?
          </p>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-yellow-800">
              <strong>Note:</strong> This will:
            </p>
            <ul className="text-xs text-yellow-700 mt-1 list-disc list-inside">
              <li>Mark the user as verified</li>
              <li>Allow them to login immediately</li>
              <li>Send them a verification confirmation email</li>
              <li>Cannot be undone</li>
            </ul>
          </div>
        </div>
      </Modal>

      {/* ✅ Change Role Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-purple-600" />
            <span>Change User Role</span>
          </div>
        }
        open={showRoleModal}
        onCancel={() => setShowRoleModal(false)}
        onOk={updateUserRole}
        okText="Update Role"
        okButtonProps={{
          className: "bg-purple-600 hover:bg-purple-700 border-purple-600",
          loading: updatingRoleUserId === selectedUser?._id,
          disabled: updatingRoleUserId === selectedUser?._id,
        }}
        cancelButtonProps={{
          disabled: updatingRoleUserId === selectedUser?._id,
        }}
        centered
      >
        <div className="py-4">
          <p className="text-gray-700 mb-4">
            Change role for <strong>{selectedUser?.username}</strong> (
            {selectedUser?.email})
          </p>
          <Select
            value={newRole}
            onChange={setNewRole}
            className="w-full"
            disabled={updatingRoleUserId === selectedUser?._id}
          >
            <Option value="user">User</Option>
            <Option value="admin">Admin</Option>
          </Select>
          <div className="mt-4 bg-purple-50 border border-purple-200 rounded-lg p-3">
            <p className="text-sm text-purple-800">
              <strong>Note:</strong> Admin users have full access to the system.
            </p>
          </div>
        </div>
      </Modal>

      {/* ✅ Edit User Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <Edit className="w-5 h-5 text-blue-600" />
            <span>Edit User Details</span>
          </div>
        }
        open={showEditModal}
        onCancel={() => setShowEditModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowEditModal(false)} disabled={editingSubmit}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={submitEditUser}
            loading={editingSubmit}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Save Changes
          </Button>,
        ]}
        width={600}
        centered
      >
        <div className="py-4 grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto pr-2">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
            <Input
              value={editFormData.username}
              onChange={(e) => setEditFormData({ ...editFormData, username: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <Input
              type="email"
              value={editFormData.email}
              onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
            <Input
              value={editFormData.phone}
              onChange={(e) => setEditFormData({ ...editFormData, phone: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
            <Select
              className="w-full"
              value={editFormData.gender}
              onChange={(val) => setEditFormData({ ...editFormData, gender: val })}
            >
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Other">Other</Option>
            </Select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
            <Input
              type="date"
              value={editFormData.DOB}
              onChange={(e) => setEditFormData({ ...editFormData, DOB: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Anniversary</label>
            <Input
              type="date"
              value={editFormData.Aniversary}
              onChange={(e) => setEditFormData({ ...editFormData, Aniversary: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Hometown City</label>
            <Input
              value={editFormData.hometowncity}
              onChange={(e) => setEditFormData({ ...editFormData, hometowncity: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Current City</label>
            <Input
              value={editFormData.city}
              onChange={(e) => setEditFormData({ ...editFormData, city: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
            <Select
              className="w-full"
              value={editFormData.role}
              onChange={(val) => setEditFormData({ ...editFormData, role: val })}
            >
              <Option value="user">User</Option>
              <Option value="admin">Admin</Option>
            </Select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">New Password (optional)</label>
            <Password
              placeholder="Leave blank to keep unchanged"
              value={editFormData.password}
              onChange={(e) => setEditFormData({ ...editFormData, password: e.target.value })}
            />
          </div>
        </div>
      </Modal>

      {/* ✅ Change Verification Status Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <CheckSquare className="w-5 h-5 text-yellow-600" />
            <span>Change Verification Status</span>
          </div>
        }
        open={showVerificationModal}
        onCancel={() => setShowVerificationModal(false)}
        onOk={updateUserVerification}
        okText="Update Status"
        okButtonProps={{
          className: "bg-yellow-600 hover:bg-yellow-700 border-yellow-600",
          loading: updatingVerificationUserId === selectedUser?._id,
          disabled: updatingVerificationUserId === selectedUser?._id,
        }}
        cancelButtonProps={{
          disabled: updatingVerificationUserId === selectedUser?._id,
        }}
        centered
      >
        <div className="py-4">
          <p className="text-gray-700 mb-4">
            Change verification status for{" "}
            <strong>{selectedUser?.username}</strong>
          </p>
          <Select
            value={newVerificationStatus}
            onChange={setNewVerificationStatus}
            className="w-full"
            disabled={updatingVerificationUserId === selectedUser?._id}
          >
            <Option value={true}>Verified</Option>
            <Option value={false}>Not Verified</Option>
          </Select>
          <div className="mt-4 bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-yellow-800">
              <strong>Note:</strong> Unverified users cannot login to the
              system.
            </p>
          </div>
        </div>
      </Modal>

      {/* ✅ Change Password Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <Key className="w-5 h-5 text-blue-600" />
            <span>Change User Password</span>
          </div>
        }
        open={showPasswordModal}
        onCancel={() => setShowPasswordModal(false)}
        onOk={changeUserPassword}
        okText="Change Password"
        okButtonProps={{
          className: "bg-blue-600 hover:bg-blue-700 border-blue-600",
          loading: changingPasswordUserId === selectedUser?._id,
          disabled: changingPasswordUserId === selectedUser?._id,
        }}
        cancelButtonProps={{
          disabled: changingPasswordUserId === selectedUser?._id,
        }}
        centered
      >
        <div className="py-4">
          <p className="text-gray-700 mb-4">
            Change password for <strong>{selectedUser?.username}</strong> (
            {selectedUser?.email})
          </p>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                New Password
              </label>
              <Password
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password (min. 8 chars, must contain a letter)"
                className="w-full"
                disabled={changingPasswordUserId === selectedUser?._id}
              />
              <p className="text-xs text-gray-500 mt-1">
                Password must be at least 8 characters long and contain at least
                one alphabet (letter)
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Confirm Password
              </label>
              <Password
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                className="w-full"
                disabled={changingPasswordUserId === selectedUser?._id}
              />
            </div>
          </div>
          <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> The user will receive an email notification
              about this change.
            </p>
          </div>
        </div>
      </Modal>

      {/* ✅ Deactivation Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2">
            {deactivationStatus ? (
              <Lock className="w-5 h-5 text-red-600" />
            ) : (
              <Unlock className="w-5 h-5 text-green-600" />
            )}
            <span>
              {deactivationStatus ? "Deactivate User" : "Reactivate User"}
            </span>
          </div>
        }
        open={showDeactivationModal}
        onCancel={() => setShowDeactivationModal(false)}
        onOk={toggleUserActivation}
        okText={deactivationStatus ? "Deactivate User" : "Reactivate User"}
        okButtonProps={{
          className: deactivationStatus
            ? "bg-red-600 hover:bg-red-700 border-red-600"
            : "bg-green-600 hover:bg-green-700 border-green-600",
          loading: togglingActivationUserId === selectedUser?._id,
          disabled: togglingActivationUserId === selectedUser?._id,
        }}
        cancelButtonProps={{
          disabled: togglingActivationUserId === selectedUser?._id,
        }}
        centered
      >
        <div className="py-4">
          <p className="text-gray-700 mb-4">
            {deactivationStatus
              ? `Deactivate user ${selectedUser?.username}?`
              : `Reactivate user ${selectedUser?.username}?`}
          </p>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <Select
              value={deactivationStatus}
              onChange={setDeactivationStatus}
              className="w-full"
              disabled={togglingActivationUserId === selectedUser?._id}
            >
              <Option value={false}>Active</Option>
              <Option value={true}>Deactivated</Option>
            </Select>
          </div>

          {deactivationStatus && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Reason for deactivation (optional)
              </label>
              <Input.TextArea
                value={deactivationReason}
                onChange={(e) => setDeactivationReason(e.target.value)}
                placeholder="Enter reason for deactivation"
                rows={3}
                disabled={togglingActivationUserId === selectedUser?._id}
              />
            </div>
          )}

          <div
            className={`mt-4 rounded-lg p-3 ${
              deactivationStatus
                ? "bg-red-50 border border-red-200"
                : "bg-green-50 border border-green-200"
            }`}
          >
            <p
              className={`text-sm ${
                deactivationStatus ? "text-red-800" : "text-green-800"
              }`}
            >
              <strong>Note:</strong>{" "}
              {deactivationStatus
                ? "Deactivated users cannot login or access any features."
                : "Reactivated users can login and access all features."}
            </p>
          </div>
        </div>
      </Modal>

      {/* Referrals Modal */}
      {showRefModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
          <div className="bg-white rounded-2xl w-full max-w-3xl overflow-hidden shadow-2xl animate-scaleIn">
            <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gradient-to-r from-gray-800 to-gray-900">
              <div>
                <h3 className="text-xl font-semibold text-white">
                  Referrals List
                </h3>
                <p className="text-gray-300 text-sm mt-1">
                  Users referred by{" "}
                  <span className="font-semibold text-white">
                    {refModalUser?.username}
                  </span>
                </p>
              </div>
              <button
                onClick={() => setShowRefModal(false)}
                className="p-2 hover:bg-gray-700 rounded-full transition-colors"
                disabled={refModalLoading}
              >
                <X className="w-5 h-5 text-white" />
              </button>
            </div>

            <div className="p-6">
              <div className="flex flex-col sm:flex-row gap-3 mb-6">
                <div className="flex-1 relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    value={refSearch}
                    onChange={(e) => setRefSearch(e.target.value)}
                    placeholder="Search referrals by username or email..."
                    className="w-full pl-10 pr=4 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        loadReferrals(refModalUser._id, 1, refLimit, refSearch);
                      }
                    }}
                    disabled={refModalLoading}
                  />
                </div>
                <button
                  onClick={() =>
                    loadReferrals(refModalUser._id, 1, refLimit, refSearch)
                  }
                  className="inline-flex items-center justify-center px-4 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={refModalLoading}
                >
                  <Search className="w-4 h-4 mr-2" />
                  Search
                </button>
              </div>

              {refModalLoading ? (
                <div className="text-center py-12">
                  <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-blue-500 border-t-transparent"></div>
                  <p className="mt-4 text-gray-600 font-medium">
                    Loading referrals...
                  </p>
                </div>
              ) : (
                <>
                  <div className="overflow-x-auto rounded-lg border border-gray-200 max-h-96">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            ID
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            Username
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            Phone
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            Email
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            Is Verified
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            Date of Birth
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                          >
                            referral code
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {referrals.length === 0 ? (
                          <tr>
                            <td colSpan={7} className="px-4 py-8 text-center">
                              <Users className="w-12 h-12 text-gray-400 mx-auto mb-3" />
                              <p className="text-gray-900 font-medium">
                                No referrals found
                              </p>
                              <p className="text-gray-500 text-sm mt-1">
                                This user hasn't referred anyone yet
                              </p>
                            </td>
                          </tr>
                        ) : (
                          referrals.map((r, i) => (
                            <tr
                              key={r._id}
                              className="hover:bg-gray-50 transition-colors"
                            >
                              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-100 text-blue-800 rounded-full text-xs">
                                  {(refPage - 1) * refLimit + i + 1}
                                </span>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                <div className="flex items-center">
                                  <User className="w-4 h-4 text-gray-400 mr-2" />
                                  {r.username}
                                </div>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                <div className="flex items-center">
                                  <Phone className="w-4 h-4 text-gray-400 mr-2" />
                                  {r.phone}
                                </div>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                <div className="flex items-center">
                                  <Mail className="w-4 h-4 text-gray-400 mr-2" />
                                  {r.email}
                                </div>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap">
                                <div className="flex items-center">
                                  {r.isVerified ? (
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                      <Check className="w-3 h-3 mr-1" />
                                      Verified
                                    </span>
                                  ) : (
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                      <X className="w-3 h-3 mr-1" />
                                      Not Verified
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                <div className="flex items-center">
                                  <Calendar className="w-4 h-4 text-gray-400 mr-2" />
                                  {formatDateOnly(r.DOB)}
                                </div>
                              </td>

                              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                <div className="flex items-center">
                                  <User className="w-4 h-4 text-gray-400 mr-2" />
                                  {r.generatedRefId}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="text-sm text-gray-700">
                      Showing{" "}
                      <span className="font-semibold">
                        {referrals.length > 0
                          ? (refPage - 1) * refLimit + 1
                          : 0}
                      </span>{" "}
                      -{" "}
                      <span className="font-semibold">
                        {Math.min(refPage * refLimit, refTotal)}
                      </span>{" "}
                      of <span className="font-semibold">{refTotal}</span>{" "}
                      referrals
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        disabled={refPage <= 1 || refModalLoading}
                        onClick={() =>
                          loadReferrals(
                            refModalUser._id,
                            Math.max(1, refPage - 1),
                            refLimit,
                            refSearch
                          )
                        }
                        className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                      >
                        <ChevronLeft className="w-4 h-4 mr-1" />
                        Prev
                      </button>
                      <button
                        disabled={
                          refPage >= Math.ceil(refTotal / refLimit) ||
                          refModalLoading
                        }
                        onClick={() =>
                          loadReferrals(
                            refModalUser._id,
                            Math.min(
                              Math.ceil(refTotal / refLimit),
                              refPage + 1
                            ),
                            refLimit,
                            refSearch
                          )
                        }
                        className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                      >
                        Next
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <WalletModal
        open={openWalletModel}
        onClose={() => setOpenWalletModel(false)}
        user={walletUser}
      />

      {/* ✅ Login as User Confirmation Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2 text-emerald-700 font-bold text-lg">
            <LogIn className="w-5 h-5 text-emerald-600" />
            <span>Login as User</span>
          </div>
        }
        open={loginAsUserModal.open}
        onCancel={() => {
          if (!loggingInUserId) {
            setLoginAsUserModal({ open: false, user: null });
          }
        }}
        footer={null}
        destroyOnClose
        centered
        className="rounded-xl overflow-hidden"
      >
        {loginAsUserModal.user && (
          <div className="space-y-4 py-2">
            <p className="text-gray-600 text-sm">
              You are about to log in as this user. You will be authenticated as this user and redirected to the user account panel at{" "}
              <a
                href="https://celestialtours.net"
                target="_blank"
                rel="noreferrer"
                className="font-semibold text-blue-600 hover:underline"
              >
                https://celestialtours.net
              </a>
              .
            </p>

            <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-emerald-600 text-white flex items-center justify-center font-bold text-lg shrink-0">
                {(
                  loginAsUserModal.user.username ||
                  loginAsUserModal.user.email ||
                  "U"
                )
                  .charAt(0)
                  .toUpperCase()}
              </div>
              <div className="min-w-0 flex-1">
                <h4 className="font-semibold text-gray-900 truncate">
                  {loginAsUserModal.user.username || "Unnamed User"}
                </h4>
                <p className="text-xs text-gray-600 truncate">
                  {loginAsUserModal.user.email}
                </p>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium bg-blue-100 text-blue-800">
                    Role: {loginAsUserModal.user.role || "user"}
                  </span>
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium ${
                      loginAsUserModal.user.isVerified
                        ? "bg-green-100 text-green-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {loginAsUserModal.user.isVerified
                      ? "Verified"
                      : "Not Verified"}
                  </span>
                  {loginAsUserModal.user.isDeactivated && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium bg-red-100 text-red-800">
                      Deactivated
                    </span>
                  )}
                </div>
              </div>
            </div>

            {loginAsUserModal.user.isDeactivated && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-xs text-red-700 flex items-center gap-2">
                <AlertCircle className="w-4 h-4 shrink-0 text-red-600" />
                <span>
                  This account is deactivated. You cannot log in until it is reactivated.
                </span>
              </div>
            )}

            {!loginAsUserModal.user.isVerified && (
              <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-xs text-yellow-800 flex items-center gap-2">
                <AlertCircle className="w-4 h-4 shrink-0 text-yellow-600" />
                <span>
                  This user's email is not verified. Please verify the user first or the login API may reject the request.
                </span>
              </div>
            )}

            <div className="flex justify-end gap-3 pt-3 border-t">
              <Button
                onClick={() =>
                  setLoginAsUserModal({ open: false, user: null })
                }
                disabled={!!loggingInUserId}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => handleLoginAsUser(loginAsUserModal.user)}
                loading={loggingInUserId === loginAsUserModal.user._id}
                disabled={loginAsUserModal.user.isDeactivated}
                className="bg-emerald-600 hover:bg-emerald-700 border-none font-medium flex items-center gap-1.5 shadow-sm"
              >
                <LogIn className="w-4 h-4" />
                Confirm & Login as User
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AllUserTable;
